<template>
<div class="row">
  <div class="w-100">
    <!-- nav bar -->
    <b-navbar toggleable type="light" variant="" class="lst-order-title">
      <!-- brand -->
      <b-navbar-brand>
        <div style="display: flex; align-items: center;">
          <i class="rs-icon-default rs-icon-logo"></i>
          <span style="color: #ced4da; padding-left: 13px;">服務履歷清單</span>
        </div>
      </b-navbar-brand>

      <!-- search bar -->
      <div class="w-100 pt-2">
        <!-- order name or order id -->
        <div class="d-flex mb-2">
          <b-form-input
            v-model="searchInput"
            placeholder="輸入客戶名稱、或訂單編號搜尋"
          ></b-form-input>
        </div>

        <!-- record scope -->
        <div class="w-100 mb-2">
          <div class="f-14">履歷範圍(切換則會立即搜尋)</div>
          <b-input-group>
            <b-form-select
              v-model="recordScope"
              :options="recordScopeOptions"
              text-field="label"
              value-field="value"
              @change="changePage(1, true)"
            >
            </b-form-select>
          </b-input-group>
        </div>

        <!-- record status -->
        <div class="w-100 mb-4" v-if="!recordScope">
          <div class="f-14">履歷狀態</div>
          <b-input-group>
            <b-form-select
              v-model="recordStatus"
              :options="recordStatusOptions"
              text-field="label"
              value-field="value"
              @change="changePage(1, false)"
            >
            </b-form-select>
          </b-input-group>
        </div>

        <!-- record status -->
        <div class="w-100 mb-2" v-if="isAllScope">
          <div class="f-14">過濾按讚</div>
          <b-input-group>
            <b-form-select
              v-model="recordVoted"
              :options="recordVotedOptions"
              text-field="label"
              value-field="value"
              @change="changePage(1, false)"
            >
            </b-form-select>
          </b-input-group>
        </div>

        <!-- staff select options -->
        <div class="w-100 mb-4" v-if="isNotSelfScope">
          <div class="f-14">過濾夥伴</div>
          <MulSelector
            placeholder       = "請選擇夥伴"
            searchPlaceholder = "請搜尋夥伴暱稱"
            v-model           = "selectStaffIds"
            :options          = "staffOptions"
          ></MulSelector>
        </div>

        <!-- submit -->
        <div class="text-right">
          <b-button
            class="re-order-filter-submit-sty"
            size="sm"
            @click="toSearch(1)">
            <span>{{ searching ? '搜尋中...' : '搜尋' }}</span>
          </b-button>
        </div>
      </div>
    </b-navbar>

    <!-- service record list -->
    <div class="order-list-contain-sty" id="sr-list">
      <div class="d-flex align-item-center p-2">
        <div class="sr__badge sr__badge--sq sr__badge--2 mr-2" style="letter-spacing: 2px;">
          <span>今日評論累積積分: {{ points.service_comment_points }}</span>
        </div>

        <div class="sr__badge sr__badge--sq sr__badge--4" style="letter-spacing: 2px;">
          <span>今日按讚累積積分: {{ points.service_like_points }}</span>
        </div>

      </div>

      <div
        class="sr__list-box"
        v-for="(record, index) in records"
        :key="index"
        @click="showServiceRecord(index)"
      >
        <div class="list-order-id-sty d-flex justify-content-between">
          <div>
            <span class="order-id-sty"># {{ record.order_id }} </span>
            <span class="list-order-time-sty">{{record.staff_name }}</span>
          </div>

          <div class="d-flex align-items-center">
            <div
              class="sr__badge sr__badge--sq sr__badge--first-service mr-1"
              style="height: 24px;"
              v-if="record.first_service"
            >首次</div>

            <div
              class="sr__badge sr__badge--sq sr__badge--recheck mr-1"
              style="height: 24px;"
              v-if="record.can_review"
            >審核單</div>

            <div
              class="sr__badge sr__badge--sq sr__badge--rm mr-1"
              style="height: 24px;"
              v-if="record.is_regular_maintenance"
            >定保</div>

            <div
              :class="`sr__badge--${record.status_value}`"
              class="sr__badge sr__badge--sq"
              style="height: 24px;"
            >{{record.status}}</div>
          </div>
        </div>

        <hr>

        <div class="list-order-maincontent-sty my-3">
          <!-- order name -->
          <div class="d-flex justify-content-between mb-2">
            <div class="label">客戶</div>
            <div class="label-content">{{ record.order_name }}</div>
          </div>

          <!-- service date -->
          <div class="d-flex justify-content-between mb-2">
            <div class="label">服務日期</div>
            <div class="label-content">{{ record.appointment_date }}</div>
          </div>

          <!-- level -->
          <div class="d-flex justify-content-between mb-2">
            <div class="label">格式類型</div>
            <div class="label-content">{{ record.level }}</div>
          </div>

          <!-- point -->
          <div
            v-if="record.current_point !== null"
            class="d-flex justify-content-between mb-2"
          >
            <div class="label">獎勵積分</div>
            <div class="label-content">{{ record.current_point }}</div>
          </div>

          <!-- exceed count -->
          <div
            v-if="record.exceed_count !== null"
            class="d-flex justify-content-between"
          >
            <div class="label">超時次數</div>
            <div class="label-content">{{ record.exceed_count }}</div>
          </div>
        </div>

        <hr>

        <div class="mb-3 list-order-maincontent-sty" @click.stop>
          <div
            class="d-flex justify-content-end"
            :class="{'justify-content-between': record.remain_spend_info || record.done}"
          >
            <b-button
              v-if="record.done"
              class="text-white btn-sm"
              variant="dark"
              size="sm"
              @click.stop="goToUserSeviceRecordPage(record.order_id)"
            >
              <span>前往客戶頁面</span>
            </b-button>

            <div
              class="label"
              v-if="record.remain_spend_info"
              :class="`sr__fill-spend-status--${record.remain_spend_info.status}`"
            >
              <span>{{ `${record.remain_spend_info.status === 3 ? '已超過' : '剩餘'}` }}時間: </span>
              <span>{{ record.remain_spend_info.hour }}時</span>
              <span>{{ record.remain_spend_info.min }}分</span>
            </div>

            <div
              class = "d-flex align-items-center"
              v-if  = "isReviewedServiceRecord(record)"
            >
              <!-- like count -->
              <div
                class       = "d-flex align-items-center mr-3"
                @click.stop = "toggleLike(record)"
              >
                <b-icon
                  role   = "button"
                  icon   = "heart-fill"
                  class  = "sr__icon sr__icon-like mr-1"
                  :class = "{'sr__icon-like--active': record.liked}"
                ></b-icon>

                <span class="sr__icon-count">{{ record.like_count }}</span>
              </div>

              <!-- comment count -->
              <div
                class       = "d-flex align-items-center"
                @click.stop = "openPanel(record)"
              >
                <b-icon
                  role   = "button"
                  style  = "position: relative;top: -1px;"
                  icon   = "chat-dots"
                  class  = "sr__icon mr-1"
                  :class = "{'sr__icon-comment--active': record.commented}"
                ></b-icon>

                <span class="sr__icon-count">{{ record.comment_count }}</span>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>

    <!-- loading -->
    <span class="lds-dual-ring" v-show="loading"></span>

    <!-- Pagination -->
     <div class="w-100 my-5 d-flex justify-content-center">
      <Pagination v-show="records.length > 0" :pgInfo="pg_info" @change="changePage"></Pagination>
     </div>

  </div>

  <!-- like and comment list -->
  <BottomSlidePanel
    :visible = "panelVisible"
    @close   = "closePanel"
  >
    <div class="sr-tab">
      <div class="sr-tab__header">
        <div
          class  = "sr-tab__header-item-box"
          @click = "getComments"
        >
          <div
            class  = "sr-tab__header-item"
            :class = "{'sr-tab__header-item--active': activePanelIdx === 0}"
          >留言</div>
        </div>

        <div
          class  = "sr-tab__header-item-box"
          @click = "getLikes"
        >
          <div
            class="sr-tab__header-item"
            :class="{'sr-tab__header-item--active': activePanelIdx === 1}"
          >讚</div>
        </div>
      </div>

      <div class="sr-tab__body">
        <!-- normal comment -->
        <CommentList
          v-if                = "activePanelIdx === 0"
          :record             = "srForPanel"
          :canNewComment      = "true"
          :canViewComments    = "true"
          :addCommentLabel    = "'新增評論'"
          @updateCommentCount = "updateCommentCount"
        ></CommentList>

        <LikeList
          v-if             = "activePanelIdx === 1"
          :record          = "srForPanel"
          @updateLikeCount = "updateLikeCount"
        ></LikeList>
      </div>
    </div>

    <!-- <button @click="panelVisible = false">關閉</button> -->
  </BottomSlidePanel>

  <portal-target name="modals" />
</div>
</template>

<script>
import Pagination from '../utils/Pagination.vue'
import MulSelector from '../utils/MulSelector.vue'
import BottomSlidePanel from './BottomSlidePanel.vue'
import CommentList from './CommentList.vue'
import LikeList from './LikeList.vue'

export default {
  name: 'ServiceRecordList',
  data () {
    return {
      lineId: '',
      searching: false,
      loading: false,
      searchInput: null,
      recordScope: null,
      recordVoted: 3,
      scrollTop: 0,
      recordScopeOptions: [
        { label: '自己', value: null },
        { label: '所有', value: 1 },
        { label: '團隊履歷', value: 3 },
        { label: '需審核的履歷', value: 2 },
        { label: '新留言', value: 4 }
      ],
      recordStatus: 5,
      recordVotedOptions: [
        { label: '無', value: 1 },
        { label: '已按讚', value: 2 },
        { label: '未按讚', value: 3 }
      ],
      recordStatusOptions: [
        { label: '未審核完成', value: 5 },
        { label: '所有', value: null },
        { label: '尚未填寫', value: 1 },
        { label: '審核中', value: 2 },
        { label: '退件需修改', value: 3 },
        { label: '審核完成', value: 4 }
      ],
      records: [],
      pg_info: { total_page: 0, current_page: 0, total_count: 0 },
      searchPage: 1,
      staffOptions: [],
      selectStaffIds: [],

      // panel
      panelVisible: false,
      activePanelIdx: 0,
      srForPanel: null,
      points: {}
    }
  },
  watch: {
    async searchInput () {
      this.changePage(1, false)
    }
  },
  computed: {
    isAllScope () {
      return this.recordScope === 1
    },
    isNotSelfScope () {
      return this.recordScope !== null && this.recordScope !== 4
    }
  },
  methods: {
    isReviewedServiceRecord (sr) {
      return sr.status_value === 4
    },
    getApiUrl (sr, action) {
      return `${this.$apiDoc.staffUrlV1}/${this.lineId}/${this.$apiDoc.apiGetService}/${sr.id}/${action}`
    },
    async getComments () {
      this.activePanelIdx = 0
    },
    async getLikes () {
      this.activePanelIdx = 1
    },
    async toggleLike (sr) {
      if (!this.isReviewedServiceRecord(sr)) {
        return
      };

      if (sr.liked && sr.is_reward_point_like) {
        var cmtDate = new Date(sr.like_created_date).toDateString()
        var today = new Date().toDateString()

        sr.is_current_reward_point_like = cmtDate === today
        if (!sr.is_current_reward_point_like) {
          var r = confirm('若取消按讚，將會取消之前獲得的積分，確定要取消按讚嗎？')
          if (!r) {
            return
          }
        }
      }

      sr.liked = !sr.liked

      this.$api.post(this.getApiUrl(sr, 'like'), { liked: sr.liked }).then(resp => {
        sr.liked = resp.liked
        sr.like_count = sr.liked ? sr.like_count + 1 : sr.like_count - 1
        sr.like_created_date = resp.like_created_date
        sr.is_reward_point_like = resp.is_reward_point_like

        this.getPoints()
      }).catch(e => {
        alert('按讚失敗，請稍後再試')
        sr.like_count = sr.liked ? sr.like_count - 1 : sr.like_count + 1
        sr.liked = !sr.liked
      })
    },
    openPanel (sr) {
      this.activePanelIdx = 0
      this.panelVisible = true
      this.srForPanel = sr
    },
    closePanel () {
      this.panelVisible = false
      this.srForPanel = null
    },
    getPoints () {
      var api = `${this.$apiDoc.staffUrlV1}/${this.lineId}/${this.$apiDoc.apiGetService}/points`
      this.$api.get(api).then(resp => {
        this.points = resp.points || {}
      }).catch(e => {
        console.error(e)
      })
    },
    updateCommentCount (count) {
      if (!this.srForPanel) {
        return
      }

      this.srForPanel.comment_count = count
      this.getPoints()
    },
    updateLikeCount (count) {
      if (!this.srForPanel) {
        return
      }

      this.srForPanel.like_count = count
    },
    goToUserSeviceRecordPage (id) {
      var srFilter = {
        searchInput: this.searchInput,
        recordScope: this.recordScope,
        recordStatus: this.recordStatus,
        recordVoted: this.recordVoted,
        searchPage: this.searchPage,
        scrollTop: document.documentElement.scrollTop || document.body.scrollTop,
        selectStaffIds: this.selectStaffIds
      }

      this.setCookie('sr_filter', JSON.stringify(srFilter))
      window.location = `https://liff.line.me/${process.env.VUE_APP_STAFF_LIFF_V1_ID}/service_records/${id}`
    },
    changePage (newPage, search = true) {
      this.searchPage = newPage

      if (search) {
        this.getRecords()
      }
    },
    async getRecords () {
      this.records = []
      this.loading = true
      try {
        var options = {
          scope: this.recordScope,
          search: this.searchInput
        }

        if (!this.recordScope) {
          if (this.recordStatus === 5) {
            options.status = [1, 2, 3]
          } else {
            options.status = this.recordStatus
          }
        }

        if (this.isAllScope) {
          options.voted = this.recordVoted
        }

        if (this.isNotSelfScope) {
          options.selected_staff_ids = this.selectStaffIds
        }

        options.page = this.searchPage

        var api = `${this.$apiDoc.staffUrlV1}/${this.lineId}/${this.$apiDoc.apiGetService}`
        const resp = await this.$api.get(api, options)
        if (!resp.service_records) {
          throw new Error('no service_records')
        }
        this.records = resp.service_records
        this.pg_info = resp.pg_info
        this.staffOptions = resp.staff_options
        this.points = resp.points || {}
      } catch (e) {
        console.error(e)
      }

      this.loading = false
    },
    async toSearch (toPage = null) {
      if (toPage !== null) {
        this.searchPage = toPage
      }

      this.searching = true
      await this.getRecords()
      this.searching = false

      this.$nextTick(() => {
        document.documentElement.scrollTop = this.scrollTop
        document.body.scrollTop = this.scrollTop
        this.scrollTop = 0
      })
    },
    showServiceRecord (index) {
      var action = 'view'
      if (this.records[index].status_value === 1) {
        action = 'edit'
      } else if (this.records[index].status_value === 2) {
        action = this.records[index].can_review && this.recordScope === 2 ? 'review' : 'view'
      } else if (this.records[index].status_value === 3) {
        action = this.records[index].can_review && this.recordScope === 2 ? 'view' : 'edit'
      }

      this.$store.dispatch('setRecordInfo', this.records[index].id)
      this.$router.push({ path: `/staff/service_records/${action}/${this.records[index].id}` })
    },
    async renewRecordContext () {
      var recordId = this.$store.state.RecordInfo
      if (!recordId) {
        return
      }

      var api = `${this.$apiDoc.staffUrlV1}/${this.lineId}/${this.$apiDoc.apiGetService}/${recordId}/context_info`
      const resp = await this.$api.get(api)
      const contextInfo = resp.context_info
      var record = this.records.find(e => e.id === recordId)
      if (!record) {
        return
      }

      record.liked = contextInfo.liked
      record.like_count = contextInfo.like_count
      record.commented = contextInfo.commented
      record.comment_count = contextInfo.comment_count
    },
    setCookie (name, value) {
      var expires = ''
      document.cookie = name + '=' + (value || '') + expires + '; path=/'
    },
    getCookie (name) {
      var nameEQ = name + '='
      var ca = document.cookie.split(';')
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i]
        while (c.charAt(0) === ' ') c = c.substring(1, c.length)
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length)
      }

      return null
    },
    delete_cookie (name) {
      document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;'
    }
  },
  async mounted () {
    // get line id
    this.lineId = this.$store.state.userId

    // get filter
    var srFilter = {}
    var srFilterJsonString = this.getCookie('sr_filter')

    // remove filter cookie
    this.delete_cookie('sr_filter')

    // for line message
    if (this.$route.query.review_scope === '1') {
      this.recordScope = 2
      return
    }

    if (this.$route.query.review_scope === '2') {
      this.recordScope = 4
      return
    }

    // for links
    if (srFilterJsonString) {
      srFilter = JSON.parse(srFilterJsonString)

      this.searchInput = srFilter.searchInput || this.searchInput
      this.recordStatus = srFilter.recordStatus
      this.recordVoted = srFilter.recordVoted || this.recordVoted

      this.scrollTop = srFilter.scrollTop || this.scrollTop
      this.searchPage = srFilter.searchPage || 1
      this.recordScope = srFilter.recordScope || this.recordScope
      this.selectStaffIds = srFilter.selectStaffIds || this.selectStaffIds
    }
  },
  async activated () {
    await this.toSearch()
  },
  beforeRouteLeave (to, from, next) {
    this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
    next()
  },
  components: {
    Pagination,
    MulSelector,
    BottomSlidePanel,
    CommentList,
    LikeList
  }
}
</script>

<style scoped>
  .sr__icon {
    width: 14px;
  }

  .label {
    font-size: .875rem;
    color: rgba(102, 102, 102, .9);
  }

  .label-content {
    font-size: .875rem;
  }

  .list-order-maincontent-sty {
    padding: 0 1rem;
  }

  .list-order-maincontent-sty > div {
    margin-bottom: 0;
  }

  hr {
    margin: .5rem;
  }
</style>
